// extracted by mini-css-extract-plugin
export default {"tagsRightPart":"src-pages-ProductEditor-Components-Tags-css__tagsRightPart--gmhvx"};